// extracted by mini-css-extract-plugin
export default {"container":"Select_container__Vu4eB","label":"Select_label__AYK8S","required":"Select_required__nG5g3","error-control":"Select_error-control__ICPSn"};